import React from 'react';
import './Rules.css';

const Rules: React.FC = () => {
  return (
    <div className="rules">
      <div className="content">
        <h1>Race Rules</h1>
        
        <div className="rules-container">
          <section>
            <h2>General Rules</h2>
            <ul className="rules-list">
              <li>All participants must check in at least 30 minutes before their event</li>
              <li>Race numbers must be visible at all times during the event</li>
              <li>Participants must follow the marked course at all times</li>
              <li>Unsportsmanlike conduct will result in disqualification</li>
            </ul>
          </section>

          <section>
            <h2>Equipment Rules</h2>
            <ul className="rules-list">
              <li>Bike helmets are REQUIRED for all cyclists</li>
              <li>Tandem bikes are only eligible for competition in the Ball & Chain division</li>
              <li>Recumbent bikes are welcome, but will not be eligible for competition</li>
              <li>Double kayaks are welcome, but will not be eligible for competition in adult divisions</li>
            </ul>
          </section>

          <section>
            <h2>Safety Rules</h2>
            <ul className="rules-list">
              <li>Follow all traffic laws and course marshal instructions</li>
              <li>Yield to emergency vehicles if present</li>
              <li>Report any injuries or emergencies to race officials immediately</li>
              <li>Wear appropriate safety gear for each event segment</li>
            </ul>
          </section>

          <section>
            <h2>Division Rules</h2>
            <ul className="rules-list">
              <li>Participants must compete in their registered division</li>
              <li>Age-based divisions use the participant's age on race day</li>
              <li>Team members must all be present for team registration</li>
              <li>Relay teams must use the designated exchange zones</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Rules; 